{
  "page": {
    "title": "Alertes snipe",
    "subtitle": "Recevez des messages Discord quand les objets, familiers ou le WoW Token que vous surveillez apparaissent sur l'hôtel des ventes en dessous de votre prix cible."
  },
  "discordRequired": {
    "title": "Discord requis",
    "description": "Vous devez lier votre compte Discord avant de pouvoir configurer les alertes snipe. Les alertes sont envoyées par message privé Discord.",
    "linkButton": "Aller dans les paramètres pour lier Discord"
  },
  "loading": "Chargement...",
  "notifications": {
    "title": "Notifications snipe",
    "description": "Recevez des alertes quand les objets ou familiers surveillés sont trouvés en dessous de votre prix cible."
  },
  "alertStyle": {
    "title": "Style d'alerte",
    "subtitle": "Choisissez comment les notifications Discord sont affichées.",
    "compact": "Compact",
    "compactDescription": "Embeds texte uniquement, sans miniatures. Plus d'alertes par message.",
    "detailed": "Détaillé",
    "detailedDescription": "Embeds enrichis avec miniatures d'objets. Un embed par objet."
  },
  "cooldown": {
    "title": "Délai d'alerte",
    "subtitle": "Nombre de cycles d'actualisation de l'hôtel des ventes (environ 1 heure chacun) à ignorer avant de ré-alerter sur la même annonce. 0 = alerter à chaque actualisation.",
    "cycles": "cycle(s)",
    "save": "Enregistrer",
    "saving": "Enregistrement..."
  },
  "realms": {
    "title": "Royaumes à surveiller",
    "subtitle": "Sélectionnez les royaumes {{region}} à surveiller pour les opportunités snipe.",
    "placeholder": "Sélectionnez les royaumes à surveiller",
    "removeRussian": "Supprimer tous les royaumes russes",
    "saveButton": "Enregistrer les royaumes",
    "savingButton": "Enregistrement..."
  },
  "addEdit": {
    "addTitle": "Ajouter un snipe {{type}}",
    "editTitle": "Modifier un snipe {{type}}",
    "typeLabel": "Type",
    "typeItem": "Objet",
    "typePet": "Familier",
    "typeToken": "Token",
    "typeIlvl": "ilvl",
    "itemNameLabel": "Nom de l'objet",
    "petNameLabel": "Nom ou ID du familier",
    "tokenLabel": "Token",
    "searchPlaceholder": "Rechercher un objet...",
    "petPlaceholder": "Entrez l'ID du familier (ex. 3390) ou recherchez par nom...",
    "priceLabelMin": "1g",
    "priceLabelMax": "9 999 999g 99s",
    "targetPriceLabel": "Prix cible",
    "pricePlaceholder": "ex. 500g ou 500g 50s",
    "ilvlMinLabel": "ilvl min",
    "ilvlMaxLabel": "ilvl max",
    "optional": "(opt)",
    "sockets": "Emplacements de gemme",
    "secondaryStats": "Caractéristiques Secondaires",
    "secondaryStatsHint": "(optionnel, choisir jusqu'à 2)",
    "statCrit": "Critique",
    "statHaste": "Hâte",
    "statVersatility": "Polyvalence",
    "statMastery": "Maîtrise",
    "noItemsFound": "Aucun objet trouvé",
    "noPetsFound": "Aucun familier trouvé",
    "anyItem": "Tout objet",
    "addButton": "Ajouter {{type}}",
    "updateButton": "Mettre à jour {{type}}",
    "addTokenButton": "Ajouter une alerte Token",
    "updateTokenButton": "Mettre à jour l'alerte Token",
    "cancelEdit": "Annuler la modification",
    "remove": "Supprimer",
    "nounItem": "objet",
    "nounPet": "familier",
    "categoryLabel": "Catégorie",
    "statSpeed": "Vitesse",
    "statLeech": "Ponction",
    "statAvoidance": "Évitement"
  },
  "importExport": {
    "importButton": "Importer JSON {{label}}",
    "importingButton": "Importation...",
    "exportIlvlButton": "Exporter JSON objets ilvl",
    "exportButton": "Exporter JSON {{label}}",
    "clearAllButton": "Tout effacer {{label}} ({{count}})",
    "pasteHint": "Tip : Appuyez sur Ctrl+V (ou Cmd+V sur Mac) n'importe où sur cette page pour coller et importer un fichier JSON directement.",
    "clearAllTitle": "Tout supprimer : {{label}}",
    "clearAllConfirmButton": "Tout supprimer"
  },
  "tabs": {
    "items": "Objets",
    "ilvlItems": "Objets ilvl",
    "pets": "Familiers",
    "token": "WoW Token"
  },
  "table": {
    "filterPlaceholder": "Filtrer par nom ou ID d'objet...",
    "countAll": "{{count}} règle(s) ilvl",
    "countFiltered": "{{filtered}} sur {{total}} règles ilvl",
    "countItems": "{{count}} {{noun}}",
    "countItemsFiltered": "{{filtered}} sur {{total}} {{noun}}",
    "colItems": "Objets",
    "colIlvl": "ilvl",
    "colStats": "Statistiques",
    "colBuyout": "Achat immédiat",
    "colActions": "Actions",
    "colTargetPrice": "Prix cible",
    "editButton": "Modifier",
    "duplicateButton": "Dupliquer",
    "deleteButton": "Supprimer",
    "emptyState": "{{hint}}",
    "emptyHintItems": "Recherchez un objet ci-dessus ou importez un fichier JSON pour commencer.",
    "emptyHintPets": "Saisissez un ID de mascotte ci-dessus ou importez un fichier JSON pour commencer.",
    "emptyHintToken": "Définissez un prix cible ci-dessus pour être averti lorsque le jeton WoW passe en dessous.",
    "emptyHintIlvl": "Définissez des limites de niveau d'objet ci-dessus ou importez un fichier JSON pour commencer.",
    "nounItems": "objet(s)",
    "nounPets": "familier(s)",
    "nounToken": "alerte de token",
    "nounIlvl": "règle(s) d'ilvl",
    "loadingName": "Chargement...",
    "colCategory": "Catégorie",
    "percentLoaded": "{{percent}}% chargés",
    "editPrice": "Modifier le prix",
    "inlineEditHint": "Cliquez pour modifier — Entrée enregistre, Échap annule"
  },
  "personalConfig": {
    "title": "Configuration des filtres personnels",
    "subtitle": "Ajustez les filtres ci-dessous pour définir vos préférences par défaut. Ceux-ci seront automatiquement appliqués lorsque vous utilisez les outils d'enchères.",
    "tip": "💡 Conseil : Configurez vos filtres comme vous le souhaitez, puis cliquez sur \"Enregistrer comme valeurs par défaut\" pour en faire vos paramètres permanents.",
    "livePreviewTitle": "Aperçu des filtres en direct",
    "livePreviewSubtitle": "Ce sont les filtres réels de l'outil d'enchères. Définissez vos valeurs par défaut selon vos besoins :",
    "saveButton": "Enregistrer les filtres par défaut",
    "resetToSavedButton": "🔄 Réinitialiser à mes valeurs par défaut enregistrées",
    "resetToSystemButton": "⚙️ Réinitialiser aux valeurs système par défaut",
    "needHelp": "Besoin d'aide avec la configuration ? Rejoignez notre Discord",
    "dashboardSection": "Filtre des opportunités du tableau de bord",
    "dashboardSectionSubtitle": "Définis la fourchette de prix d'achat immédiat des objets affichés dans le widget des Meilleures Opportunités du tableau de bord.",
    "dashboardBuyoutMin": "Achat min. (Or)",
    "dashboardBuyoutMax": "Achat max. (Or)",
    "dashboardBuyoutMaxHint": "Mets 0 pour aucun maximum",
    "dashboardSaveButton": "Enregistrer la configuration du tableau de bord",
    "itemMatchingSection": "Paramètres de correspondance d'articles",
    "itemMatchingSectionSubtitle": "Contrôlez comment les variantes d'articles sont correspondées entre les royaumes lors du calcul des opportunités.",
    "ignoreStatsBeforeExpansion": "Ignorer les statistiques secondaires avant cette extension",
    "ignoreStatsBeforeExpansionHint": "Les articles des extensions antérieures à celle sélectionnée seront traités comme identiques quelle que soit leur affixe de statistique secondaire. Utile pour les anciens articles hérités où les différences de statistiques n'affectent pas la valeur d'échange.",
    "ignoreStatsNone": "Aucun (désactivé)",
    "itemMatchingSaveButton": "Enregistrer les paramètres de correspondance"
  },
  "inventoryAnalysis": {
    "premiumRequired": "Vous avez besoin d'un abonnement premium actif pour utiliser l'outil !",
    "subscriptionRequired": "Vous avez besoin d'un abonnement actif pour utiliser l'outil !",
    "pasteCSVFirst": "Veuillez d'abord coller vos données CSV d'inventaire.",
    "csvPasted": "CSV d'inventaire collé.",
    "pasteHint": "Tip : Appuyez sur Ctrl+V (ou Cmd+V sur Mac) n'importe où sur cette page pour coller votre CSV d'inventaire directement.",
    "noValidItems": "Aucun objet valide trouvé dans les données CSV. Vérifiez le format.",
    "analysisComplete": "Analyse terminée ! {{opportunities}} opportunités de vente trouvées pour {{items}} objets d'inventaire.",
    "analysisFailed": "Échec de l'analyse de l'inventaire. Veuillez réessayer.",
    "title": "Analyse d'inventaire",
    "description": "Collez votre export CSV d'inventaire en jeu ci-dessous. Nous analyserons chaque objet sur tous les royaumes disponibles pour trouver les meilleures opportunités de vente.",
    "addonInstall": "Installez l'addon depuis",
    "addonInstallHere": "ici",
    "csvFormatTitle": "Format CSV attendu",
    "csvFormatNote": "Délimité par des points-virgules. Les BonusIDs sont séparés par des deux-points (ex.",
    "csvModifiersNote": "). Les modificateurs utilisent",
    "csvModifiersFormat": "type=valeur",
    "csvModifiersExample": "format (ex.",
    "sellingRealmsTitle": "Royaumes de vente pour l'inventaire",
    "suggestedDropships": "Dropships suggérés",
    "inventoryDataLabel": "Données d'inventaire",
    "itemsDetected": "{{count}} objet détecté",
    "itemsDetectedPlural": "{{count}} objets détectés",
    "uploadFile": "Téléverser un fichier",
    "analyzeButton": "Analyser {{count}} objets",
    "analyzeInventoryButton": "Analyser l'inventaire",
    "clearButton": "Effacer",
    "backToInput": "Retour à la saisie d'inventaire",
    "noOpportunities": "Aucune opportunité de vente trouvée pour vos objets d'inventaire.",
    "noOpportunitiesReason": "Cela peut arriver si les objets n'ont pas de données de marché TSM ou ne sont pas échangeables.",
    "tryAgain": "Réessayer",
    "exportCSV": "Exporter pour FlipQueue"
  },
  "realmConfig": {
    "setupGuideLink": "Cliquez ici pour le guide de configuration de l'outil",
    "selectRegion": "Sélectionner la région actuelle",
    "updateBuyingRealms": "Mettre à jour les royaumes d'achat pour {{region}} ({{selected}} sur {{total}})",
    "updateSellingRealms": "Mettre à jour les royaumes de vente pour {{region}} ({{selected}} sur {{max}})",
    "sellingRealmLimitTooltip": "En tant qu'abonné avec un abonnement {{type}}, vous ne pouvez sélectionner que {{max}} royaumes de vente.",
    "addAllToBuying": "Ajouter tous les royaumes aux royaumes d'achat",
    "removeAllFromBuying": "Supprimer tous les royaumes des royaumes d'achat",
    "removeRussianFromBuying": "Supprimer tous les royaumes russes des royaumes d'achat",
    "addAllToSelling": "Ajouter tous les royaumes aux royaumes de vente",
    "removeAllFromSelling": "Supprimer tous les royaumes des royaumes de vente",
    "removeRussianFromSelling": "Supprimer tous les royaumes russes des royaumes de vente",
    "wowAccountsTitle": "Comptes WoW",
    "addAccount": "Ajouter un compte",
    "accountNamePlaceholder": "Nom du compte (ex. WoW2)",
    "accountNameRequired": "Le nom du compte est obligatoire",
    "addAccountFailed": "Échec de l'ajout du compte",
    "deleteAccountDefault": "Impossible de supprimer le compte par défaut",
    "deleteAccountConfirm": "Êtes-vous sûr ? Ce compte sera supprimé de toutes les attributions de royaumes.",
    "deleteAccountFailed": "Échec de la suppression du compte",
    "updateAccountFailed": "Échec de la mise à jour du nom du compte",
    "assignRealmsLabel": "Attribuer des royaumes aux comptes (un royaume peut être dans plusieurs comptes) :",
    "selectAll": "Tout sélectionner",
    "deselectAll": "Tout désélectionner",
    "noRealmsSelected": "Aucun royaume sélectionné",
    "addMoreAccounts": "Ajoutez d'autres comptes pour attribuer des royaumes à différents comptes WoW.",
    "saveButton": "Enregistrer toutes les données",
    "missingAccountsError": "Veuillez attribuer au moins un compte à chaque royaume. Manquants : {{realms}}",
    "discordQuestion": "Encore des questions ? Rejoignez notre Discord",
    "navigateToFlippingTool": "Flipping Tool",
    "navigateToDropshipTool": "Dropship Tool",
    "navigateToHousingTool": "Housing Tool",
    "navigateToTSMListGenerator": "Générateur de liste TSM",
    "saveButtonDirty": "Enregistrer les modifications •",
    "saveSettingsFailed": "Impossible d'enregistrer les paramètres",
    "unsavedTitle": "Modifications non enregistrées",
    "unsavedLeaveMessage": "Vous avez des paramètres de royaumes non enregistrés. Si vous quittez cette page, vos modifications seront perdues.",
    "unsavedLeaveConfirm": "Quitter sans enregistrer",
    "unsavedStay": "Rester sur la page",
    "saveBeforeNavTitle": "Enregistrer vos modifications ?",
    "saveBeforeNavMessage": "Votre sélection de royaumes contient des modifications non enregistrées. Enregistrez-les pour que l'outil utilise vos nouveaux paramètres.",
    "saveAndContinue": "Enregistrer et continuer",
    "deleteAccountTitle": "Supprimer le compte WoW",
    "deleteAccountMessage": "Supprimer le compte « {{name}} » ? Il sera retiré de toutes les assignations de royaumes.",
    "deleteAccountConfirmButton": "Supprimer",
    "renameAccountAria": "Renommer le compte {{name}}",
    "deleteAccountAria": "Supprimer le compte {{name}}",
    "confirmRenameAria": "Enregistrer le nom du compte",
    "cancelRenameAria": "Annuler le renommage",
    "confirmAddAria": "Ajouter le compte",
    "cancelAddAria": "Annuler l'ajout du compte"
  },
  "tsmProfile": {
    "title": "Guide de configuration du profil TSM",
    "realmPriceAnalysis": "Analyse des prix du royaume",
    "minimumPriceOperation": "Opération prix minimum",
    "maximumPriceOperation": "Opération prix maximum",
    "normalPriceOperation": "Opération prix normal",
    "copyButton": "Copier",
    "copiedSuccess": "L'opération de prix TSM {{operation}} a été copiée dans le presse-papiers !",
    "copyFailed": "Échec de la copie dans le presse-papiers"
  },
  "tsmListGenerator": {
    "subscriptionRequired": "Vous avez besoin d'un abonnement actif pour utiliser l'outil !",
    "watchVideoGuide": "Voir le guide vidéo",
    "copyTSMString": "Copier la chaîne TSM",
    "copyTSMFailed": "Échec de la copie de la chaîne TSM dans le presse-papiers",
    "videoGuideTitle": "Guide vidéo du générateur de liste TSM",
    "emptyTitle": "Aucune donnée d'enchères trouvée",
    "emptyDescription": "Aucune donnée d'enchères ne correspond à vos royaumes configurés. Vérifiez votre configuration de royaumes ou réessayez après la prochaine mise à jour de l'hôtel des ventes.",
    "emptyConfigureButton": "Configurer les royaumes",
    "emptyRetryButton": "Réessayer"
  },
  "realmStats": {
    "subscriptionRequired": "Vous avez besoin d'un abonnement actif pour utiliser l'outil !",
    "overallStatistics": "Statistiques globales",
    "realmPriceAnalysis": "Analyse des prix du royaume",
    "watchVideoGuide": "Voir le guide vidéo",
    "noData": "Aucune donnée de royaume disponible",
    "legend": "Légende",
    "legendCheap": "Plutôt bon marché (<{{ratio}})",
    "legendNormal": "Autour de la normale ({{min}}-{{max}})",
    "legendExpensive": "Significativement cher (>{{ratio}})",
    "tooltipCheap": "Cela signifie que les objets sont généralement plus proches de la moyenne de vente régionale en termes de prix. Il est donc plutôt bon marché d'acheter ici, mais moins bon pour vendre.",
    "tooltipNormal": "Cela signifie que les objets sont mitigés par rapport à la moyenne de vente régionale. Il peut être bon d'acheter et de vendre.",
    "tooltipExpensive": "Cela signifie que les objets sont généralement bien au-dessus de la moyenne de vente régionale. Il est plutôt cher d'acheter ici, mais cela peut être bon pour vendre.",
    "colRealmName": "Nom du royaume",
    "colPopulation": "Population",
    "colAuctions": "Enchères",
    "colPriceRatio": "Ratio de prix",
    "colCheaper": "Moins cher",
    "colExpensive": "Plus cher",
    "colPercentCheaper": "% Moins cher",
    "colPercentExpensive": "% Plus cher",
    "colPercentEqual": "% Égal",
    "totalRealms": "Royaumes totaux",
    "totalAuctions": "Enchères totales",
    "avgPriceRatio": "Ratio de prix moyen",
    "cheaperThanRegion": "Moins cher que la région",
    "totalAuctionsHistory": "Historique des enchères totales",
    "avgPriceRatioHistory": "Historique du ratio de prix moyen",
    "percentCheaperHistory": "Historique % moins cher",
    "auctionsHistory": "{{realm}} - Historique des enchères",
    "priceRatioHistory": "{{realm}} - Historique du ratio de prix",
    "cheaperCountHistory": "{{realm}} - Historique du nombre moins cher",
    "expensiveCountHistory": "{{realm}} - Historique du nombre plus cher",
    "percentCheaperRealm": "{{realm}} - Historique % moins cher",
    "percentExpensiveRealm": "{{realm}} - Historique % plus cher",
    "percentEqualRealm": "{{realm}} - Historique % égal",
    "videoTitle": "Guide vidéo de l'outil de statistiques de royaume"
  },
  "tsmDataTable": {
    "colItemName": "Nom de l'objet",
    "colCategory": "Catégorie",
    "colExpansion": "Extension",
    "colSellRate": "Taux de vente",
    "colSaleAvg": "Moy. de vente",
    "colRegionMarketValue": "Valeur marchande régionale",
    "colRegionHistorical": "Historique régional",
    "clickToCopy": "Cliquer pour copier : {{name}}",
    "tooltipSaleAvg": "Prix moyen auquel un objet a été vendu au cours des 60 derniers jours",
    "tooltipMarketValue": "Prix moyen auquel un objet a été mis en vente au cours des 14 derniers jours sur tous les royaumes de votre région",
    "tooltipHistorical": "Prix moyen auquel un objet a été mis en vente au cours des 60 derniers jours sur tous les royaumes de votre région"
  },
  "import": {
    "confirmTitle": "Confirmer l'importation",
    "confirmMessage": "Importer {{count}} entrées dans la liste {{tab}} ?",
    "confirmMessageCategory": "Importer {{count}} entrées dans la liste {{tab}} (catégorie : {{category}}) ?",
    "confirmButton": "Importer"
  }
}
